<template>
  <DialogConfirm />
  <DialogWarningGlobal />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
